<template>
  <div id="filter-private-plot-type">
    <div>
      <vs-row vs-type="flex" class="mt-2">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="6"
        >
          <span class="aisea-text-16-400-white">全て</span>
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="6"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="allSwitch" />
        </vs-col>
      </vs-row>

      <vs-divider class="mb-0" :color="AISEA_COLOR.GRAY" />

      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-plot-img" :src="constructionIcon" />
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="5"
        >
          <span class="aisea-text-16-400-white ml-5">工事区域</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="6"
        >
          <vs-switch
            :color="AISEA_COLOR.BLUE"
            v-model="constructionAreaSwitch"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-plot-img" :src="restrictionIcon" />
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="5"
        >
          <span class="aisea-text-16-400-white ml-5">航行制限区域</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="6"
        >
          <vs-switch
            :color="AISEA_COLOR.BLUE"
            v-model="restrictionAreaSwitch"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-plot-img" :src="usefulIcon" />
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="5"
        >
          <span class="aisea-text-16-400-white ml-5">お役立ち</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="6"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="usefulAreaSwitch" />
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-plot-img" :src="attentionIcon" />
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="5"
        >
          <span class="aisea-text-16-400-white ml-5">注意</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="6"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="attentionAreaSwitch" />
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-plot-img" :src="emergencyIcon" />
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="5"
        >
          <span class="aisea-text-16-400-white ml-5">緊急</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="6"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="emergencyAreaSwitch" />
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import { PrivatePlotMixin, ColorMixin } from "@/mixins";
import LocalDbService from "@/services/localDbService";
import FireStoreService from "@/services/fireStoreService";
import { createNamespacedHelpers } from "vuex";
import _ from "lodash";

// Store
const { mapActions: mapActionsOfLiveMap } = createNamespacedHelpers("liveMap");

export default {
  name: "PrivatePlotType",
  mixins: [PrivatePlotMixin, ColorMixin],
  data() {
    return {
      isAllSwitchOnEvent: false,
      isAllFilterOffEvent: false,
      localFilterPrivatePlots: [],
      allSwitch: false,
      constructionAreaSwitch: false,
      restrictionAreaSwitch: false,
      usefulAreaSwitch: false,
      attentionAreaSwitch: false,
      emergencyAreaSwitch: false,
      constructionIcon: require("@/assets/images/plot/childCategory/UnderConstruction_w@96x-8.png"),
      restrictionIcon: require("@/assets/images/plot/childCategory/LimitedNavigationArea_w@96x-8.png"),
      usefulIcon: require("@/assets/images/plot/childCategory/LeisureSpot_w@96x-8.png"),
      attentionIcon: require("@/assets/images/plot/childCategory/Shallows_w@96x-8.png"),
      emergencyIcon: require("@/assets/images/plot/childCategory/AccidentReport_w@96x-8.png"),
    };
  },
  watch: {
    localFilterPrivatePlots(val) {
      this._setFilterPrivatePlots(this, val);
    },
    async allSwitch(isOn) {
      if (isOn) {
        if (!this.isAllSwitchOnEvent) {
          await this.setAllFilter(true);
          let filterPrivatePlots = this.getPrivatePlotParentCategoryIds();
          this.localFilterPrivatePlots = filterPrivatePlots;
        } else {
          this.isAllSwitchOnEvent = false;
        }
      } else {
        this.localFilterPrivatePlots = [];
        this.isAllFilterOffEvent = true;
        await this.setAllFilter(false);
        this.isAllFilterOffEvent = false;
      }
    },
    constructionAreaSwitch(isOn) {
      this.setFilterState(
        isOn,
        String(this.privatePlotParentCategory.CONSTRUCTION),
      );
    },
    restrictionAreaSwitch(isOn) {
      this.setFilterState(
        isOn,
        String(this.privatePlotParentCategory.RESTRICTION),
      );
    },
    usefulAreaSwitch(isOn) {
      this.setFilterState(isOn, String(this.privatePlotParentCategory.USEFUL));
    },
    attentionAreaSwitch(isOn) {
      this.setFilterState(
        isOn,
        String(this.privatePlotParentCategory.ATTENTION),
      );
    },
    emergencyAreaSwitch(isOn) {
      this.setFilterState(
        isOn,
        String(this.privatePlotParentCategory.EMERGENCY),
      );
    },
  },
  methods: {
    ...mapActionsOfLiveMap(["setFilterPrivatePlots"]),
    _setFilterPrivatePlots: _.debounce((self, val) => {
      let filterPrivatePlots = _.cloneDeep(val);
      FireStoreService.saveFilterPrivatePlots(filterPrivatePlots);
      LocalDbService.saveFilterPrivatePlots(filterPrivatePlots);
      self.setFilterPrivatePlots(filterPrivatePlots);
    }, 1000),
    setFilterState(isOn, privatePlotCategory) {
      if (this.isAllFilterOffEvent) return;
      if (isOn) {
        this.localFilterPrivatePlots.push(privatePlotCategory);
      } else {
        this.filterPrivatePlot(privatePlotCategory);
      }
      if (this.localFilterPrivatePlots.length === 0) {
        this.allSwitch = false;
      }
      if (
        this.getPrivatePlotParentCategoryIds().length ===
        this.localFilterPrivatePlots.length
      ) {
        this.allSwitch = true;
      }
    },
    filterPrivatePlot(id) {
      this.localFilterPrivatePlots = this.localFilterPrivatePlots.filter(
        (v) => {
          return v !== id;
        },
      );
    },
    async setAllFilter(val) {
      this.constructionAreaSwitch = val;
      this.restrictionAreaSwitch = val;
      this.usefulAreaSwitch = val;
      this.attentionAreaSwitch = val;
      this.emergencyAreaSwitch = val;
    },
    async setFilterSwitch(filterPrivatePlots) {
      filterPrivatePlots.forEach((type) => {
        switch (Number(type)) {
          case this.privatePlotParentCategory.CONSTRUCTION:
            this.constructionAreaSwitch = true;
            break;
          case this.privatePlotParentCategory.RESTRICTION:
            this.restrictionAreaSwitch = true;
            break;
          case this.privatePlotParentCategory.USEFUL:
            this.usefulAreaSwitch = true;
            break;
          case this.privatePlotParentCategory.ATTENTION:
            this.attentionAreaSwitch = true;
            break;
          case this.privatePlotParentCategory.EMERGENCY:
            this.emergencyAreaSwitch = true;
            break;
        }
      });
    },
  },
  async created() {
    let filterPrivatePlots = await LocalDbService.getFilterPrivatePlots();
    if (filterPrivatePlots.length === 0) {
      this.allSwitch = false;
      await this.setAllFilter(false);
      this.localFilterPrivatePlots = filterPrivatePlots;
    } else {
      await this.setFilterSwitch(filterPrivatePlots);
      this.localFilterPrivatePlots = filterPrivatePlots;
    }
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#filter-private-plot-type {
  background: $aisea-blue-gray;

  .filter-plot-img {
    height: 20px;
    width: 20px;
  }
}
</style>
